<div class="side-detail-container">
  <h3><mat-icon>local_hospital</mat-icon> ข้อมูลโรงพยาบาล</h3>
  <ng-container *ngIf="site">
    <h4>ข้อมูลทั่วไป</h4>
    <div class="upload-logo">
      <img class="logo" [src]="logoUrl">
      <button class="long" *ngIf="!readonly" mat-stroked-button color="primary" (click)="editLogo()">อัพโหลดรูปใหม่</button>
    </div>
    <app-modal-input [readonly]="readonly" inLabel="ชื่อโรงพยาบาล" [inF]="fg.get('name')" (outValue)="editFormGroup($event)">
      <ng-template>
        <mat-form-field>
          <mat-label>ชื่อโรงพยาบาล</mat-label>
          <input matInput placeholder="ชื่อโรงพยาบาลที่ใช้ในการแสดงผล" [formControl]="fg.get('name')" required>
          <mat-error>{{e.addHospitalHospitalNameMissing}}</mat-error>
        </mat-form-field>
      </ng-template>
    </app-modal-input>
    <app-modal-input [readonly]="readonly" inLabel="ไอดีโรงพยาบาล" [inF]="fg.get('displayId')" (outValue)="editFormGroup($event)">
      <ng-template>
        <mat-form-field>
          <mat-label>ไอดีโรงพยาบาล</mat-label>
          <input matInput placeholder="ไอดีโรงพยาบาลที่ใช้ในการแสดงผล" [formControl]="fg.get('displayId')" required>
          <mat-error>{{e.addHospitalHospitalIDMissing}}</mat-error>
        </mat-form-field>
      </ng-template>
    </app-modal-input>
    <app-modal-input [readonly]="readonly" inLabel="ลำดับการแสดง" [inF]="fg.get('displayOrder')" (outValue)="editFormGroup($event)">
      <ng-template>
        <mat-form-field [floatLabel]="'always'">
          <mat-label>ลำดับการแสดง</mat-label>
          <input type="number" matInput placeholder="กรุณากรอกลำดับการแสดง" [formControl]="fg.get('displayOrder')">
          <mat-error *ngIf="fg.get('displayOrder').hasError('pattern')">
            {{e.addHospitalHospitalOrderNumber}}
          </mat-error>
        </mat-form-field>
      </ng-template>
    </app-modal-input>
    <h4>สถานะโรงพยาบาล</h4>
    <ng-container *ngIf="readonly;else canToggle">
      <span *ngIf="site.isEnabled" class="enabled"> สามารถให้บริการได้</span>
      <span *ngIf="!site.isEnabled" class="disabled"> ไม่สามารถให้บริการได้</span>
    </ng-container>
    <ng-template #canToggle>
      <mat-slide-toggle
          #slide
          class="radio-label-fill" labelPosition="before" [(ngModel)]="site.isEnabled"
          (change)="confirmEnableChanged($event)" color="primary">
        <span *ngIf="site.isEnabled" class="enabled"> สามารถให้บริการได้</span>
        <span *ngIf="!site.isEnabled" class="disabled"> ไม่สามารถให้บริการได้</span>
      </mat-slide-toggle>
    </ng-template>
    <br>
    <div class='flex-spacer'></div>
    <br>
    <ng-container *ngIf="!readonly">
      <h4>ลบโรงพยาบาล</h4>
      <div class="text-center">
        <button
            class="long"
            mat-stroked-button color="warn"
            (click)="confirmDeleteDialog(null, null)"
            *ngIf="!readonly">
          ลบโรงพยาบาล
        </button>
      </div>
    </ng-container>
  </ng-container>
</div>
